import { createApp } from 'vue'
import LineupSearch from './modules/vue/LineupSearch.vue'
import DealerMapSearch from './modules/vue/DealerMapSearch.vue'
import EstimateList from './modules/vue/EstimateList.vue'
import EstimateOption from './modules/vue/EstimateOption.vue'
import EstimateResult from './modules/vue/EstimateResult.vue'
import Swiper from 'swiper/bundle'

document.addEventListener('DOMContentLoaded', () => {
  const banners = document.querySelector('[data-banner-json]')
  let bannerJson = []
  if (banners) {
    bannerJson = banners.textContent ? JSON.parse(banners.textContent) : []
  }

  if (document.querySelector('#dealerMap')) {
    createApp(DealerMapSearch).mount('#dealerMap')
  }

  if (document.querySelector('#lineupNewSearch')) {
    const appLineupSearchNew = createApp(LineupSearch, {
      type: 'new',
      banner: bannerJson,
    })
    appLineupSearchNew.mount('#lineupNewSearch')
  }
  if (document.querySelector('#lineupUsedSearch')) {
    const appLineupSearchUsed = createApp(LineupSearch, {
      type: 'used',
      banner: bannerJson,
    })
    appLineupSearchUsed.mount('#lineupUsedSearch')
  }
  if (document.querySelector('#lineupTestSearch')) {
    const appLineupSearchTest = createApp(LineupSearch, {
      type: 'test',
    })
    appLineupSearchTest.mount('#lineupTestSearch')
  }
  if (document.querySelector('#lineupUnusedSearch')) {
    const appLineupSearchUsed = createApp(LineupSearch, {
      type: 'unused',
      banner: bannerJson,
    })
    appLineupSearchUsed.mount('#lineupUnusedSearch')
  }
  if (document.querySelector('#estimateList')) {
    const appEstimateList = createApp(EstimateList)
    appEstimateList.mount('#estimateList')
  }
  if (document.querySelector('#estimateOption')) {
    const appEstimateOption = createApp(EstimateOption)
    appEstimateOption.mount('#estimateOption')
  }
  if (document.querySelector('#estimateResult')) {
    const appEstimateResult = createApp(EstimateResult)
    appEstimateResult.mount('#estimateResult')
  }

  if (document.querySelector('#details-thumbs')) {
    const detailsThumbs = new Swiper('#details-thumbs', {
      spaceBetween: 8,
      slidesPerView: 5,
      freeMode: true,
      watchSlidesProgress: true,
    })

    const detailsSlider = new Swiper('#details-slider', {
      loop: true,
      spaceBetween: 0,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: detailsThumbs,
      },
    })
  }
})
